export default { sha: '969f3ebdc58520741195a535bbe48544d9d8a7b5', buildNumber: 'undefined' }
